import styled from "styled-components";

export const Container = styled.section`
    width: 100%;    
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;

    color: #58626c;
    padding: 0 6rem;
    
    h1 {
        font-family: 'Great Vibes', sans-serif;
        font-size: 4rem;
        font-weight: 200;
    }    

    @media (max-width: 770px) {
        padding: 0 1rem;
    }

    @media (max-width: 500px) {
        h1 {
            font-size: 3rem;
        }
    }

`

export const Content = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;

    margin-top: 30px;

    label {
        margin-right: auto;
        margin-bottom: 5px;
    }

    input {
        margin-bottom: 20px;
    }
    
    input, textarea {
        background: transparent;
        border: 2px solid #58626c;
        border-radius: 7px;
        padding: 10px;
        width: 500px;

        ::-webkit-scrollbar {
            width: 5px;
        }

        ::-webkit-scrollbar-track {
            background-color: transparent;
        }

        ::-webkit-scrollbar-thumb {
            background-color: #87868b;
            border-radius: 20px;
        }
        
        ::-webkit-scrollbar-thumb:hover {
            background-color: #696969;
        }
    }
    @media (max-width: 500px) {
        width: 100%;
        input, textarea {
            width: 100%;
        }
    }

    button {
        padding: 10px 20px;
        border-radius: 10px;
        border: 0;
        background-color: #e2799b;
        color: #fff;
        font-weight: bold;
        margin-top: 20px;
        margin-left: auto;
        opacity: 1;        
    }
    
    button:hover {
        opacity: 0.9;        
    }
`

export const Recado = styled.div`
    margin-right: auto;
    width: 100%;

    margin-top: 30px;

    div {
        border-left: 10px solid var(--rose);
        padding: 0 10px;
        border-radius: 10px;
        margin: 30px auto;
    }

    p {
        word-wrap: break-word;
    }
`